/**
 * ROOFTOP_SPIDERWEB — realism pass for the 5x-tall synthwave skyscraper variant (roof decals, parapet aviation masts with red beacons; no facade plumbing on glass towers).
 * All logic is shared by the rooftop family: see `rooftopsLayout.ts` (pure
 * layout + contract) and `rooftopsBuild.ts` (merged meshes). Contract bench:
 * `agent/bench-extras-rooftops.mjs`.
 */
export const mapIds = ["rooftop_spiderweb"];
export { buildRooftopExtras as build } from "./rooftopsBuild.js";
